import styled from 'styled-components';

const DetailNotFound = styled.div`
  color: var(--greyWolf);
`;

export { DetailNotFound };
